import { findKey } from "lodash";

const prepareFireeyeResult = data => {
  const fireeyeResultOptions = {
    no: "goodware",
    yes: "malicious"
  };
  const fireeyeResultKey = findKey(data, o => o.key === "malicious");
  if (fireeyeResultKey) {
    const fireeyeResult = data[fireeyeResultKey].value;
    return fireeyeResultOptions[fireeyeResult] || "unknown";
  }
};

export { prepareFireeyeResult };
